import { HStack } from "@/components/layout";
import { cx } from "@/utils";

const themes = {
  success: { bg: "bg-cp-success", text: "text-cp-success" },
  error: { bg: "bg-cp-error", text: "text-cp-error" },
  not_started: { bg: "bg-cp-grey-400", text: "text-cp-grey-800" },
  processing: { bg: "bg-cp-warning", text: "text-cp-grey-800" },
};

export const StatusCell = ({ label, variant }) => {
  const theme = themes[variant];

  return (
    <HStack className="items-center gap-2">
      <span className="relative flex size-2 whitespace-nowrap">
        {variant === "processing" && (
          <span
            className={cx(
              theme.bg,
              "absolute size-full animate-ping rounded-full opacity-90",
            )}
          />
        )}
        <span className={cx("size-2 rounded-full", theme.bg)} />
      </span>

      <p className={cx("font-medium", theme.text)}>{label}</p>
    </HStack>
  );
};
